import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import config from '../../config';

import styles from './CreatePasswordPage.css';

class CreatePasswordPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        match: PropTypes.object.isRequired,
    };

    state = {
        password: '',
        repeat: '',
        error: '',
        done: false,
    };

    handleSaveClick = () => {
        const { password, repeat } = this.state;
        const {
            intl: { formatMessage },
            match: {
                params: { token },
            },
        } = this.props;

        if (!password) {
            this.setState({ error: formatMessage({ id: 'CreatePasswordPage.fill in password' }) });
            return;
        }

        if (password !== repeat) {
            this.setState({ error: formatMessage({ id: 'CreatePasswordPage.passwords must be the same' }) });
            return;
        }

        fetch(`${config.backend}/recover/set`, {
            method: 'POST',
            body: JSON.stringify({ password, token }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        })
            .then(res => {
                if (res.ok) {
                    this.setState({ done: true });
                } else {
                    this.setState({ error: formatMessage({ id: 'CreatePasswordPage.Cannot set password' }) });
                }
            })
            .catch(() => this.setState({ error: formatMessage({ id: 'CreatePasswordPage.Cannot set password' }) }));
    };

    handleKeyDown = e => {
        if (e.which === 13) {
            this.handleSaveClick();
        }
    };

    renderDone() {
        return (
            <Fragment>
                <FormattedMessage id="CreatePasswordPage.Success" />
                <Link to="/signin" className={styles.done}>
                    <FormattedMessage id="CreatePasswordPage.sign in" />
                </Link>
            </Fragment>
        );
    }

    render() {
        const {
            intl: { formatMessage },
        } = this.props;

        if (this.state.done) {
            return this.renderDone();
        }

        return (
            <Fragment>
                <FormattedMessage id="CreatePasswordPage.create new password" />
                <TextField
                    floatingLabelText={formatMessage({ id: 'CreatePasswordPage.new password' })}
                    onChange={(e, password) => this.setState({ password })}
                    fullWidth
                    type="password"
                    errorText={this.state.error}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <TextField
                    floatingLabelText={formatMessage({ id: 'CreatePasswordPage.repeat password' })}
                    onChange={(e, repeat) => this.setState({ repeat })}
                    fullWidth
                    type="password"
                    onKeyDown={this.handleKeyDown}
                />
                <RaisedButton
                    label={formatMessage({ id: 'CreatePasswordPage.save' })}
                    onClick={this.handleSaveClick}
                    primary
                    className={styles.button}
                />
            </Fragment>
        );
    }
}

export default injectIntl(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/Pages/CreatePasswordPage/CreatePasswordPage.js